class PatternGallery {

    constructor(element) {

        this.gallery = element;

        this.items = [...element.querySelectorAll(".gallery-item")];
        this.images = [...element.querySelectorAll(".gallery-image")];

        this.lightboxItems = this.images.map(image => ({

            src: image.dataset.full,
            title: image.dataset.title,
            alt: image.alt || image.dataset.title

        }));

        this.bindEvents();
        this.layout();

        this.resizeTimer = null;

        window.addEventListener("resize", () => {

            clearTimeout(this.resizeTimer);

            this.resizeTimer = setTimeout(() => {

                this.layout();

            }, 50);

        });

        window.addEventListener("load", () => this.layout());

    }

    /* =====================================================
       Layout
    ===================================================== */

    getColumns() {

        const styles = getComputedStyle(this.gallery);

        if (window.innerWidth < 640) {

            return Math.max(
                1,
                parseInt(styles.getPropertyValue("--columns-mobile")) || 1
            );

        }

        if (window.innerWidth < 990) {

            return Math.max(
                1,
                parseInt(styles.getPropertyValue("--columns-tablet")) || 1
            );

        }

        return Math.max(
            1,
            parseInt(styles.getPropertyValue("--columns-desktop")) || 1
        );

    }

    layout() {

        requestAnimationFrame(() => {

            const styles = getComputedStyle(this.gallery);

            const columns = this.getColumns();
            const gap = parseFloat(styles.getPropertyValue("--gallery-gap")) || 0;

            const width = this.gallery.clientWidth - gap * 8;
            const itemWidth = (width - gap * (columns - 1)) / columns;

            const columnHeights = new Array(columns).fill(0);

            this.items.forEach((item, index) => {

                item.classList.remove("big", "small");

                const column = index % columns;
                const row = Math.floor(index / columns);

                const big = (row + column) % 2 === 0;

                item.classList.add(big ? "big" : "small");

                item.style.width = itemWidth + "px";

                const height = big
                    ? itemWidth * 1.25
                    : itemWidth;

                item.style.height = height + "px";

                item.style.left =
                    gap * 4 + column * (itemWidth + gap) + "px";

                item.style.top =
                    gap * 4 + columnHeights[column] + "px";

                columnHeights[column] += height + gap;

            });

            this.gallery.style.height =
                Math.max(...columnHeights) + "px";

        });

    }

    /* =====================================================
       Events
    ===================================================== */

    bindEvents() {

        this.items.forEach((item, index) => {

            item.addEventListener("click", () => {

                if (!window.CustomLightbox)
                    return;

                window.CustomLightbox.open({

                    items: this.lightboxItems,
                    index

                });

            });

        });

    }

}

/* =========================================================
   Init
========================================================= */

function initPatternGallery() {

    document
        .querySelectorAll(".pattern-gallery")
        .forEach(gallery => {

            if (gallery.instance)
                return;

            gallery.instance =
                new PatternGallery(gallery);

        });

}

document.addEventListener(
    "DOMContentLoaded",
    initPatternGallery
);

document.addEventListener(
    "shopify:section:load",
    initPatternGallery
);